import { requestUrl, oauthRequestUrl } from "@/config/config";
// 结算列表
export const getList = `${requestUrl}/admin/withdrawal/page`;

// 结算处理
export const save = `${requestUrl}/admin/withdrawal/handle`;